(function () {
  var ATTR_INIT = "data-byte-pdp-video-init";
  var MIN_VISIBLE_RATIO = 0.22;
  var THRESHOLDS = [0, 0.1, 0.2, 0.35, 0.5, 0.65, 0.8, 1];

  function pauseVideosIn(section) {
    if (!section) return;
    section.querySelectorAll("video").forEach(function (video) {
      video.pause();
    });
  }

  function playWrapperVideo(wrapper) {
    if (!wrapper || wrapper.dataset.mediaType !== "video") return;
    var video = wrapper.querySelector("video");
    if (!video) return;
    var p = video.play();
    if (p && typeof p.catch === "function") p.catch(function () {});
  }

  function setupViewportVideos(section) {
    var wrappers = Array.from(section.querySelectorAll('[data-product-media-wrapper][data-media-type="video"]'));
    if (!wrappers.length) return;

    var ratios = new Map();
    var lastPlayed = null;
    var raf = 0;

    wrappers.forEach(function (w) {
      ratios.set(w, 0);
    });

    function pickMostVisible() {
      var best = null;
      var bestRatio = 0;
      wrappers.forEach(function (w) {
        var r = ratios.get(w);
        if (typeof r !== "number" || r <= 0) return;
        if (r > bestRatio) {
          bestRatio = r;
          best = w;
        }
      });

      if (!best || bestRatio < MIN_VISIBLE_RATIO) return;
      if (best === lastPlayed) return;
      lastPlayed = best;
      pauseVideosIn(section);
      playWrapperVideo(best);
    }

    function schedulePick() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        raf = 0;
        pickMostVisible();
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
      schedulePick();
    }, {
      root: null,
      rootMargin: "0px",
      threshold: THRESHOLDS
    });

    wrappers.forEach(function (w) {
      observer.observe(w);
    });

    window.setTimeout(schedulePick, 150);
  }

  function initProductMedia(section) {
    if (!section || section.getAttribute(ATTR_INIT) === "true") return;
    section.setAttribute(ATTR_INIT, "true");
    setupViewportVideos(section);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="product"][data-is-full-product="true"]').forEach(initProductMedia);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var target = e.target;
    var section = target && target.matches && target.matches('[data-section-type="product"]') ? target : target && target.querySelector && target.querySelector('[data-section-type="product"]');

    if (section && section.dataset.isFullProduct === "true") {
      section.removeAttribute(ATTR_INIT);
      initProductMedia(section);
    }
  });
})();
